export default class MouseInteraction {
  constructor(options = {}) {
    this._tech = options.tech;
    this._inactivityTimeout = undefined;
  }

  tech() {
    return this._tech;
  }

  instance() {
    return this.tech().plugin().instance();
  }

  controlbar() {
    return this.instance().controlBar;
  }

  options() {
    return this.instance().options_;
  }

  inactivityTimeout(timeout) {
    this.options().inactivityTimeout = timeout;
  }

  init() {
    this.setDefaultInactivityTimeout();
    this.playerMouseenter();
    this.playerMouseleave();
    this.controlbarMouseenter();
    this.controlbarMouseleave();
  }

  setDefaultInactivityTimeout() {
    this._inactivityTimeout = this.options().inactivityTimeout;
  }

  playerMouseenter() {
    this.tech().on('mouseenter', () => {
      this.tech().plugin().instance().userActive(true);
      this.inactivityTimeout(this._inactivityTimeout);
    });
  }

  playerMouseleave() {
    this.tech().on('mouseleave', () => {
      this.inactivityTimeout(100);
      this.tech().plugin().instance().userActive(false);
    });
  }

  controlbarMouseenter() {
    this.controlbar().on('mouseenter', () => {
      this.inactivityTimeout(0);
    });
  }

  controlbarMouseleave() {
    this.controlbar().on('mouseleave', () => {
      this.inactivityTimeout(this._inactivityTimeout);
    });
  }
}
